module.exports = __webpack_public_path__ + "static/media/lockheed_logo.14f380c3.jpg";